import RestClient from './rest-client'

export default class Dashboard extends RestClient {
  static get url () {
    return this.apiUrl + '/dashboards'
  }

  static async sendSupportEmail (params) {
    await this._post(this.url + `/send_support_email`, params)
  }
}
